import { constants, IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { IError } from 'interfaces/review/IReviewDataRow';
import { IReviewPlayerExtended } from 'interfaces/review/IReviewPlayer';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';
import { getPlayerFromColumn } from './ValidationHelpers';

const PositionDict: { [index: string]: string } = {
  pitcher: 'Pitcher',
  batter: 'Batter',
  catcher: 'Catcher',
};

export const basicPlayerValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    const columnObj = {} as { [key in DataKey]: IDataGridColumnConfiguration };

    for (const column of columns) {
      columnObj[column.dataKey as DataKey] = column;
    }

    const { pitcher, batter, catcher } = columnObj;

    if (!pitcher || !batter || !catcher) {
      return rows.map(() => []);
    }

    return rows.map((r) => validateRow(r, pitcher, batter, catcher));
  },
};

const validateRow = (
  row: ReviewDataRow,
  pitcherColumn: IDataGridColumnConfiguration,
  batterColumn: IDataGridColumnConfiguration,
  catcherColumn: IDataGridColumnConfiguration
): IError[] => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }

  const pitcher = getPlayerFromColumn(row, pitcherColumn);
  const batter = getPlayerFromColumn(row, batterColumn);
  const catcher = getPlayerFromColumn(row, catcherColumn);

  const defensivePositions = [pitcher, batter, catcher];

  const isNotSamePosition = (firstPlayer: IReviewPlayerExtended, secondPlayer: IReviewPlayerExtended): boolean => {
    return firstPlayer.defaultPosition !== secondPlayer.defaultPosition && firstPlayer.id === secondPlayer.id;
  };

  const isNotDuplicated = (fpPosition: string, spPosition: string): boolean => {
    return !errors.find((error) => error.dataKey === `${spPosition}-${fpPosition}`);
  };

  const playerHasNoEmptyGuid = (firstPlayer: IReviewPlayerExtended, secondPlayer: IReviewPlayerExtended): boolean => {
    return firstPlayer.id !== constants.emptyGuid && secondPlayer.id !== constants.emptyGuid;
  };

  defensivePositions.forEach((firstPlayer) => {
    if (!firstPlayer.id) {
      return;
    }

    defensivePositions.forEach((secondPlayer) => {
      if (!secondPlayer.id) {
        return;
      }

      const fpPosition = PositionDict[firstPlayer.defaultPosition];
      const spPosition = PositionDict[secondPlayer.defaultPosition];

      if (
        isNotSamePosition(firstPlayer, secondPlayer) &&
        isNotDuplicated(fpPosition, spPosition) &&
        playerHasNoEmptyGuid(firstPlayer, secondPlayer)
      ) {
        errors.push({
          dataKey: `${fpPosition}-${spPosition}`,
          errorMessage: `${fpPosition} is same as ${spPosition}`,
        });
      }
    });
  });

  return errors;
};
